<template>
  <div class="sf-question-multi" role="group" :aria-labelledby="labelId">
    <p :id="labelId" class="visually-hidden">{{ question.prompt }}</p>
    <div class="sf-question-multi__options">
      <label
        v-for="option in normalizedOptions"
        :key="option.value"
        class="sf-question-multi__option"
        :class="{ 'is-checked': isSelected(option) }"
      >
        <input
          type="checkbox"
          class="sf-question-multi__checkbox"
          :value="option.value"
          :checked="isSelected(option)"
          @change="toggleOption(option)"
        />
        <span class="sf-question-multi__label-text">{{ option.label }}</span>
      </label>
    </div>
    <div class="sf-question-multi__actions">
      <button
        class="sf-question-multi__confirm"
        :disabled="selection.length === 0"
        @click="confirm"
      >
        Verder
      </button>
    </div>
  </div>
</template>

<script>
import { normalizeOptions } from './normalizeOptions';

let counter = 0;

export default {
  name: 'QuestionMulti',

  props: {
    question: { type: Object, required: true },
  },

  emits: ['answer'],

  data() {
    return {
      selection: [],
      labelId: 'sf-multi-label-' + (++counter),
    };
  },

  computed: {
    normalizedOptions() {
      return normalizeOptions(this.question.options);
    },
  },

  methods: {
    isSelected(option) {
      return this.selection.includes(option.value);
    },

    toggleOption(option) {
      const idx = this.selection.indexOf(option.value);
      if (idx === -1) {
        this.selection.push(option.value);
      } else {
        this.selection.splice(idx, 1);
      }
    },

    confirm() {
      if (this.selection.length === 0) return;
      const selected = new Set(this.selection);
      const labels = this.normalizedOptions
        .filter((option) => selected.has(option.value))
        .map((option) => option.label)
        .join(', ');
      this.$emit('answer', {
        slot: this.question.slot || this.question.id,
        value: this.selection,
        label: labels,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sf-question-multi {
  padding: 8px 16px 16px;
  max-width: 390px;
  width: 100%;
  margin: 0 auto;

  &__options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  }

  &__option {
    display: flex;
    align-items: center;
    gap: 12px;
    border: 0.5px solid #b5afa5;
    border-radius: 12px;
    padding: 12px 16px;
    cursor: pointer;
    background: #fff;
    transition: background 0.15s, border-color 0.15s;

    &.is-checked {
      background: #e5bb5f;
      border-color: #e5bb5f;
    }

    &:hover:not(.is-checked) {
      border-color: #517b86;
    }
  }

  &__checkbox {
    width: 18px;
    height: 18px;
    accent-color: #517b86;
    cursor: pointer;
    flex-shrink: 0;
  }

  &__label-text {
    font-family: 'Comfortaa', sans-serif;
    font-size: 14px;
    color: #23201e;
    user-select: none;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
  }

  &__confirm {
    background: #23201e;
    color: #fff;
    border: none;
    border-radius: 24px;
    padding: 10px 24px;
    font-family: 'Comfortaa', sans-serif;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.2s;

    &:disabled {
      opacity: 0.4;
      cursor: default;
    }

    &:not(:disabled):hover {
      opacity: 0.85;
    }

    &:focus-visible {
      outline: 2px solid #517b86;
      outline-offset: 2px;
    }
  }
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
</style>
